import React, { useState, useEffect } from "react"
import { getUser } from "@starberry/myaccount-website-utils"
import { Form } from "react-bootstrap"

import InputField from './elements/input'
import SelectField from './elements/select'
import TextAreaField from './elements/textarea'
import CheckboxField from './elements/checkbox'
import RadioField from './elements/radio'
import ButtonField from './elements/button'
import HtmlBox from './elements/html'
import ReCaptchaBox from './elements/recaptcha'
import { postFormData, nameValidation, emailValidation } from "./api/Api"
import $ from "jquery"
import axios from "axios"
import * as qs from "query-string"
import _ from "lodash";


function MySimpleForm(props) {
  const userData = getUser();
  const [startDate, setStartDate] = useState();
  const [startTime, setStartTime] = useState();
  const [validated, setValidated] = useState(false);
  const [showerror, setShowerror] = useState(false);
  const [showthankyou, setThankyou] = useState(false);
  const [enqytype, setEnqytype] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const [formvalues, setFormvalues] = useState("");

  const [token, setToken] = useState("");

  const myRef = React.createRef();

  const recaptchaRef = React.createRef();



  const fields = [
    {
      element: "config",
      formname: "Book a Viewing",
      form_type: "contact",
      error_text: "Highlighted fields are required",
      success_text: "Thank you for contacting us. A member of our team will contact you shortly.",
      email_temp_user: "book_viewing_user",
      email_temp_admin: "book_viewing_admin",
      email_subject_user: "Book a Viewing",
      email_subject_admin: "Book a Viewing",
      email_server_func: "book_a_viewing",
      event_tracking: "contact",
      page_url: "/general-enquiry"
    },
    {
      grpmd: "12",
      label: "Name",
      placeholder: "Enter your first name here",
      name: "name",
      type: "text",
      element: "input",
      class: "form__field",
      required: true,
      patternchk: "^[-a-zA-Z0-9-()]+(\\s+[-a-zA-Z0-9-()]+)*$",
      labelClass: "content_b-18",
      defaultValue: userData?.name || ``
    },

    {
      grpmd: "12",
      label: "Your Email Address",
      placeholder: "Enter your email here",
      name: "email",
      type: "email",
      class: "form__field",
      element: "input",
      required: true,
      patternchk: "[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$",
      labelClass: "content_b-18",
      defaultValue: userData?.email || ``
    },
    {
      grpmd: "12",
      label: "Your Telephone",
      placeholder: "Enter your telephone number here",
      name: "telephone",
      type: "text",
      class: "form__field",
      element: "input",
      required: true,
      patternchk: "^[+]*[0-9-()]+(\\s+[0-9-()]+)*.{9}$",
      labelClass: "content_b-18",
      defaultValue: userData?.mobile || ``
    },
    {
      grpmd: "12",
      label: "Property Address",
      placeholder: "Enter property address here",
      name: "address",
      type: "text",
      element: "input",
      class: "form__field",
      required: true,
      labelClass: "content_b-18",
      value: props.subject.property_address ? props.subject.property_address : ''
    },
    {
      grpmd: "12",
      label: "",
      placeholder: "Preferred date",
      name: "date",
      type: "datetime",
      element: "input",
      class: "form__field form-control",
      // min: today,
      // max: maxday.toString(),
      required: true,
      patternchk: ""
    },
    {
      grpmd: "12",
      label: "Message",
      placeholder: "Enter your message here",
      class: "form__field form__field-textarea",
      name: "message",
      element: "textarea",
      rows: "5",
      labelClass: "content_b-18"
    },

    {
      grpmd: "12",
      name: "Submit",
      type: "submit",
      element: "button",
      value: "submit",
      class: "btn btn--fill-darkblue",
      labelClass: "content_b-18"
    },

    {
      element: "captcha",
      class: "py-2",
      captchaRef: recaptchaRef
    },
  ];


  const handlechange = event => {
    // remove initial empty spaces
    event.target.value = event.target.value.trimStart()
  }
  const handleselectchange = event => {
    // remove initial empty spaces
    setEnqytype(event[0].value);
  }
  useEffect(() => {
    if (token !== '') {

      const processFromData = async () => {
        formvalues['g-recaptcha-response'] = token;
        let formData = new FormData();

        // formvalues['extra'] = JSON.stringify({
        //   message: formvalues.message,
        //   name: formvalues.name
        // });
        formvalues['name'] = formvalues.name;
        formvalues['email_subject_user'] = fields[0].email_subject_user;
        formvalues['email_subject_admin'] = fields[0].email_subject_admin;

        formData.append('data', JSON.stringify(formvalues));

        postFormData(formData).then(async apiRes => {
        window.grecaptcha.reset()

          // lets send mail
          await window.fetch(`${process.env.GATSBY_CLOUD_URL}/api/form`, {
            method: `POST`,
            mode: "no-cors",
            headers: {
              'Access-Control-Allow-Origin': '*',
              "Content-Type": "application/x-www-form-urlencoded",
            },
            body: qs.stringify(formvalues),
          })

        });

        const url = typeof window !== 'undefined' ? window.location.href : ''
        if (url.indexOf("property") > -1 && fields[4].event_tracking_decider) {
          fields[0].formname = 'Get mortgage help';
        }
        // tracking event
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event': 'formSubmit',
          'formType': 'form-' + fields[0].event_tracking,
          'formId': 'form-' + fields[0].event_tracking,
          'formName': fields[0].formname,
          'formLabel': fields[0].formname
        });

        setShowerror(false);
        setThankyou(true);
        myRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' })

      }
      processFromData();

    }
  }, [token]);

  const handleonVerify = token => {
    console.log("captcha verified");
    setToken(token);
  };

  const stopSubmission = (event, elementid, errormsg) => {
    if (errormsg) {
      setErrorMessage(errormsg);
    }
    event.preventDefault();
    event.stopPropagation();
    setShowerror(true);
    setValidated(true);
    setThankyou(false);
    if (elementid) {
      const element = document.getElementById(elementid);
      if (element) {
        element.focus();
        element.select();
      }
    }
    myRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' })
  }

  const handleSubmit = event => {

    const form = event.currentTarget;

    if (form.checkValidity() === false) {
      $(".form-field-group input").each(function () {
        if ($(this).is(":invalid")) {
          $(this).closest(".form-field-group").addClass("invalid--field");
        } else {
          $(this).closest(".form-field-group").removeClass("invalid--field");
        }
      })
      // event.preventDefault();
      // event.stopPropagation();
      // setShowerror(true);
      // setValidated(true);
      // setThankyou(false);
      // myRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
      stopSubmission(event);
    }
    else {

      const name = $("input[name='name']");
      const email = $("input[name='email']");
      if (name.val() !== "") {
        const fvalid = nameValidation(name.val());
        if (!fvalid.valid) {
          stopSubmission(event, "validationname", fvalid.message);
        } else if (email.val() !== "") {
          const evalid = emailValidation(email.val());
          if (!evalid.valid) {
            stopSubmission(event, "validationemail", evalid.message);
          } else {
            event.preventDefault();
            const formsdata = (event.target);
            const json = {}
            Object.keys(formsdata).map(key => (
              json[formsdata[key].name] = (formsdata[key].checked) ? 'yes' : formsdata[key].value
            ))

            json['email_temp_user'] = fields[0].email_temp_user;
            json['email_temp_admin'] = fields[0].email_temp_admin;
            json['formname'] = fields[0].formname;
            json['property_id'] = props.subject.property_id ? props.subject.property_id : '';
            json['property_url'] = props.subject.property_url ? props.subject.property_url : '';
            json['property_title'] = props.subject.property_title ? props.subject.property_title : '';
            json['property_list'] = props.subject.properties ? props.subject.properties : '';
            json['property_img'] = props.subject.property_img ? props.subject.property_img : '';
            json['property_address'] = props.subject.property_address ? props.subject.property_address : '';
            json['property_bedrooms'] = props.subject.property_bedrooms ? props.subject.property_bedrooms : '';
            json['property_bathrooms'] = props.subject.property_bathrooms ? props.subject.property_bathrooms : '';
            json['g-recaptcha-response'] = token;
            json['extra'] = _.omit(json, ["formname", "name", "email", "telephone"])

            setFormvalues(json);
            recaptchaRef.current.execute();
            setValidated(false);
            setErrorMessage('');
            // reset form
            const form = event.target
            form.reset();
            setStartDate();
            setStartTime();
          }
        }
      }
    }
  };

  return (
    <div className="form stbform  contact-form  common_form_class" id="BookingForm">
      <div ref={myRef} />
      <div className="form-wraps input-wraps">
        {errorMessage &&
          <div className="alert-error">
            <p>{errorMessage ? errorMessage : fields[0].error_text}</p>
          </div>
        }

        {showthankyou && <div className="alert-success">
          <p>{fields[0].success_text}</p>
        </div>}
        <Form className="contact-form form-w-label" name={fields[0].formname} action="/thank-you/" method="post" noValidate validated={validated} onSubmit={handleSubmit}>
          <input type="hidden" name="form_name" value={fields[0].formname} />
          <input type="hidden" name="form_type" value={fields[0].form_type} />
          <input type="hidden" name="to_email_id" value={props.to_email_id} />
          <input type="hidden" name="property_url" value={props.subject.property_url} />
          <input type="hidden" name="office_url" value={props.subject.officeurl} />
          <input type="hidden" name="bot-field" />
          {fields.map((field, index) => {
            if ("radio" === field.element) {
              return (
                <RadioField
                  name={field.name}
                  ref={field.ref}
                  value={field.value}
                  fieldClass={field.class}
                  checked={field.checked}
                  placeholder={field.placeholder}
                  required={field.required}
                  key={`${field.name}~${index}`}
                  handlechange={handlechange}
                  lastchild={field.lastchild}
                  type={field.type}
                />
              );
            }

          })
          }
          {fields.map((field, index) => {
            if ("input" === field.element) {
              return (
                <InputField
                  name={field.name}
                  grpmd={field.grpmd}
                  ref={field.ref}
                  type={field.type}
                  fieldClass={field.class}
                  placeholder={field.placeholder}
                  startDate={field.type === 'datetime' ? startDate : ''}
                  setStartDate={field.type === 'datetime' ? setStartDate : ''}
                  startTime={field.type === 'datetime' ? startTime : ''}
                  setStartTime={field.type === 'datetime' ? setStartTime : ''}
                  label={field.label}
                  labelClass={field.labelClass}
                  value={field.value}
                  required={field.required}
                  key={`${field.element}~${index}`}
                  pattern={field.patternchk}
                  handlechange={handlechange}
                  defaultValue={field?.defaultValue}
                />
              );
            }
            if ("select" === field.element) {
              return (
                <SelectField
                  name={field.name}
                  grpmd={field.grpmd}
                  ref={field.ref}
                  required={field.required}
                  fieldClass={field.class}
                  placeholder={field.placeholder}
                  values={field.values}
                  key={`${field.element}~${index}`}
                  handlechange={handleselectchange}
                  componentprops={props}
                />
              );
            }
            if ("textarea" === field.element) {
              return (
                <TextAreaField
                  name={field.name}
                  grpmd={field.grpmd}
                  ref={field.ref}
                  rows={field.rows}
                  fieldClass={field.class}
                  label={field.label}
                  labelClass={field.labelClass}
                  placeholder={field.placeholder}
                  required={field.required}
                  key={`${field.element}~${index}`}
                  handlechange={handlechange}
                />
              );
            }
            if ("checkbox" === field.element) {
              return (
                <CheckboxField
                  name={field.name}
                  ref={field.ref}
                  value={field.value}
                  label={field.label}
                  fieldClass={field.class}
                  placeholder={field.placeholder}
                  required={field.required}
                  key={`${field.name}~${index}`}
                  handlechange={handlechange}
                />
              );
            }

            if ("html" === field.element) {
              return (
                <HtmlBox
                  text={field.text}
                  fieldClass={field.class}
                  key={`${field.element}~${index}`}
                />
              );
            }
            if ("captcha" === field.element) {
              return (
                <ReCaptchaBox
                  fieldClass={field.class}
                  captRef={field.captchaRef}
                  key={`${field.element}~${index}`}
                  handleonVerify={handleonVerify}
                />
              );
            }
            if ("button" === field.element) {
              return (
                <ButtonField
                  name={field.name}
                  fieldClass={field.class}
                  type={field.type}
                  value={field.value}
                  key={`${field.element}~${index}`}
                />
              );
            }
          })
          }
        </Form>
      </div>
    </div>
  );
}


const BookingForm = (props) => (
  <MySimpleForm to_email_id={props.to_email_id} property_url={props.property_url} subject={props} />
)

export default BookingForm